<template>
  <div class="product-details card">
    <div>
      Show below 
      <el-select v-model="pageSize" style="width:120px;margin-left:10px;" @change="fetchDetails">
        <el-option label="10 pcs" :value="10"></el-option>
        <el-option label="20 pcs" :value="20"></el-option>
        <el-option label="30 pcs" :value="30"></el-option>
        <el-option label="40 pcs" :value="40"></el-option>
        <el-option label="50 pcs" :value="50"></el-option>
        <el-option label="60 pcs" :value="60"></el-option>
        <el-option label="80 pcs" :value="80"></el-option>
        <el-option label="100 pcs" :value="100"></el-option>
      </el-select>
    </div>
    <el-row :gutter="10" style="margin-top:10px;">
      <el-col :span="13">
        <div class="table-title">
          <label>Quotation</label>
        </div>
        <table class="fixed-table">
          <tr>
            <th style="width:90px;">input time</th>
            <th style="width:85px;">company</th>
            <th style="width:55px;">qty</th>
            <th style="width:75px;">price</th>
            <th style="width:60px;">leadtime</th>
            <th style="width:80px;">remark</th>
            <th>sales</th>
          </tr>
          <tr v-for="item in quotationList" :key="item.id">
            <td>{{ item.oper_time | shortDateTime }}</td>
            <td :title="item.company_name">{{ item.company_name }}</td>
            <td>{{ item.display_c_qty }}</td>
            <td>{{ item.display_c_price }}</td>
            <td>{{ item.c_lead_time }}</td>
            <td :title="item.c_remark">{{ item.c_remark }}</td>
            <td>
              <el-tooltip class="item" effect="dark" :content="item.sales_fullname + ',input by ' + item.oper_name" placement="bottom">
                <span>{{ item.sales_name }}</span>
              </el-tooltip>
            </td>
          </tr>
        </table>
        <no-data :loading="loading" :list="quotationList"></no-data>
      </el-col>
      <el-col :span="11">
        <div class="table-title">
          <label>Requirement</label>
        </div>
        <table class="fixed-table">
          <tr>
            <th style="width:90px;">input time</th>
            <th style="width:85px;">company</th>
            <th style="width:55px;">qty</th>
            <th style="width:75px;">price</th>
            <th style="width:75px;">remark</th>
            <th>sales</th>
          </tr>
          <tr v-for="item in requirementList" :key="item.id">
            <td>{{ item.oper_time | shortDateTime }}</td>
            <td :title="item.company_name">{{item.company_name}}</td>
            <td>{{item.qty}}</td>
            <td>{{ !item.price ? 'no TP' : item.currency + item.price }}</td>
            <td :title="item.remark">{{item.remark}}</td>
            <td>
              <el-tooltip class="item" effect="dark" :content="item.sales_fullname + ',input by ' + item.oper_name" placement="bottom">
                <span>{{ item.sales_name }}</span>
              </el-tooltip>
            </td>
          </tr>
        </table>
        <no-data :loading="loading" :list="requirementList"></no-data>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="margin-top:10px">
      <el-col :span="12">
        <div class="table-title">
          <label>PO</label>
        </div>
        <table class="fixed-table">
          <tr>
            <th style="width:65px;">date</th>
            <th style="width:65px;">po no.</th>
            <th>company</th>
            <th style="width:50px;">qty</th>
            <th style="width:70px;">cost</th>
            <th style="width:35px;">sales</th>
            <th style="width:20px;">&nbsp;</th>
          </tr>
          <tr v-for="item in poList" :key="item.id">
            <td>{{ item.doc_date }}</td>
            <td v-if="user.role_id<3||item.create_oper_id==user.id"><a @click="$open(`/po-order-view/${item.doc_id}`, 840)">CYS{{ item.doc_id }}</a></td>
            <td v-else>PI CYS{{ item.doc_id }}</td>
            <td :title="item.company_fullname" v-if="user.role_id<3||item.create_oper_id==user.id">{{item.company_fullname}}</td>
            <td v-else>&nbsp;</td>
            <td style="text-align:right;">{{item.qty|1000}}</td>
            <td>{{item.currency}}{{item.price}}</td>
            <td>{{item.sales_name}}</td>
            <td style="text-align:center;">
              <a @click="$open(`/order-photo/po/${item.doc_id}`, 800)" v-if="item.photo_count > 0">
                <i class="el-icon-picture" style="color:#409eff;font-weight:bold;"></i>
              </a>
            </td>
          </tr>
        </table>
        <no-data :loading="loading" :list="poList"></no-data>
      </el-col>
      <el-col :span="12">
        <div class="table-title">
          <label>PI</label>
        </div>
        <table class="fixed-table">
          <tr>
            <th style="width:65px;">date</th>
            <th style="width:65px;">pi no.</th>
            <th>company</th>
            <th style="width:50px;">qty</th>
            <th style="width:65px;">price</th>
            <th style="width:65px;">cost</th>
            <th style="width:35px;">sales</th>
            <th style="width:20px;">&nbsp;</th>
          </tr>
          <tr v-for="item in invoiceList" :key="item.id">
            <td>{{ item.doc_date }}</td>
            <td v-if="user.role_id<3||item.create_oper_id==user.id"><a @click="$open(`/invoice-order-view/${item.doc_id}`, 840)">CYS{{ item.doc_id }}</a></td>
            <td v-else>CYS{{ item.doc_id }}</td>
            <td :title="item.company_fullname" v-if="user.role_id<3||item.create_oper_id==user.id">{{item.company_fullname}}</td>
            <td v-else>&nbsp;</td>
            <td style="text-align:right;">{{item.qty|1000}}</td>
            <td>{{item.currency}}{{item.price|1000}}</td>
            <td>{{item.currency}}{{item.bb_cost>0?item.bb_cost:(item.hk_cost>0?item.hk_cost:item.sz_cost)}}</td>
            <td>{{item.sales_name}}</td>
            <td style="text-align:center;">
              <a @click="$open(`/order-photo/pi/${item.doc_id}`, 800)" v-if="item.photo_count > 0">
                <i class="el-icon-picture" style="color:#409eff;font-weight:bold;"></i>
              </a>
            </td>
          </tr>
        </table>
        <no-data :loading="loading" :list="invoiceList"></no-data>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import NoData from '@/components/NoData'
export default {
  components: {
    NoData
  },
  data () {
    return {
      requirementList: [],
      quotationList: [],
      poList: [],
      invoiceList: [],
      pageSize: 20,
      loading: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  mounted () {
    this.fetchDetails()
  },
  methods: {
    fetchDetails () {
      this.fetchRequirement()
      this.fetchQuotation()
      this.fetchPo()
      this.fetchInvoice()
    },
    fetchRequirement () {
      this.$http.get('/dbapi/product_requirement_list?product_id=' + this.$route.params.id + '&start=0&limit=' + this.pageSize).then(data => {
        this.requirementList = data.list
      })
    },
    fetchQuotation () {
      this.$http.get('/dbapi/product_offer_list?product_id=' + this.$route.params.id + '&start=0&limit=' + this.pageSize).then(data => {
        this.quotationList = data.list
      })
    },
    fetchPo () {
      this.$http.get('/dbapi/po_list?product_id=' + this.$route.params.id + '&start=0&limit=' + this.pageSize).then(data => {
        this.poList = data.list
      })
    },
    fetchInvoice () {
      this.$http.get('/dbapi/invoice_list?product_id=' + this.$route.params.id + '&start=0&limit=' + this.pageSize).then(data => {
        this.invoiceList = data.list
      })
    }
  }
}
</script>